<template>
  <v-dialog
    :value="value"
    max-width="600"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="headline primary white--text">
        <v-icon left color="white">mdi-sync</v-icon>
        Activar Suscripciones
      </v-card-title>

      <v-card-text class="pt-6">
        <!-- Funcionalidades -->
        <div class="mb-6">
          <h3 class="text-h6 font-weight-bold mb-3">
            <v-icon left color="success">mdi-check-circle</v-icon>
            Funcionalidades incluidas:
          </h3>
          <v-list dense>
            <v-list-item v-for="feature in features" :key="feature.text">
              <v-list-item-icon>
                <v-icon color="success" small>{{ feature.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-body-2">{{ feature.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- Advertencia de Comisión -->
        <v-alert
          type="warning"
          color="orange"
          prominent
          border="left"
          colored-border
          elevation="2"
        >
          <v-row align="center">
            <v-col class="grow">
              <h4 class="text-subtitle-1 font-weight-bold mb-2">
                <v-icon left color="orange">mdi-alert</v-icon>
                Comisión Adicional
              </h4>
              <p class="text-body-2 mb-2">
                Al activar las suscripciones, se aplicará la comisión estándar 
                <strong class="black--text">(3.6% + 3 pesos + IVA)</strong> y un adicional de 0.7% + IVA 
                sobre cada transacción recurrente.
              </p>
              <p class="text-caption text--secondary mb-0">
                Esta comisión cubre los costos de procesamiento automático, gestión de reintentos 
                y mantenimiento de la infraestructura de suscripciones.
              </p>
            </v-col>
          </v-row>
        </v-alert>

        <!-- Checkbox de Confirmación -->
        <div class="mt-4">
          <v-checkbox
            v-model="localAcceptTerms"
            color="primary"
            hide-details
          >
            <template v-slot:label>
              <span class="text-body-2">
                He leído y acepto la comisión total de la comisión estándar 
                <strong class="black--text">(3.6% + 3 pesos + IVA)</strong> y un adicional de 0.7% + IVA por transacción
              </span>
            </template>
          </v-checkbox>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="handleCancel"
          :disabled="activating"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :loading="activating"
          :disabled="!localAcceptTerms || activating"
          @click="handleConfirm"
        >
          <v-icon left>mdi-check</v-icon>
          Activar Suscripciones
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  
  props: {
    value: {
      type: Boolean,
      required: true
    },
    activating: {
      type: Boolean,
      default: false
    },
    features: {
      type: Array,
      default: () => [
        {
          icon: 'mdi-autorenew',
          text: 'Cobros automáticos recurrentes según el período de membresía'
        },
        {
          icon: 'mdi-credit-card-refresh',
          text: 'Gestión automática de reintentos de pago'
        },
        {
          icon: 'mdi-email-outline',
          text: 'Notificaciones automáticas a miembros sobre pagos'
        },
        {
          icon: 'mdi-calendar-clock',
          text: 'Período de gracia configurable para pagos fallidos'
        },
        {
          icon: 'mdi-shield-check',
          text: 'Gestión segura de métodos de pago'
        }
      ]
    }
  },

  data() {
    return {
      localAcceptTerms: false
    };
  },

  watch: {
    value(newVal) {
      if (!newVal) {
        // Reset accept terms when dialog closes
        this.localAcceptTerms = false;
      }
    }
  },

  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },

    handleCancel() {
      this.localAcceptTerms = false;
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del diálogo si son necesarios */
</style>
